import _ from "lodash";
import { createUuid, Color } from "@ts3d-hoops/web-viewer";

import {
  cubeSheetId,
  cubeCameraData,
  cubeMarkup,
  cubeSelectionData,
  cubeColorData,
  cubeMagnitudeData,
  cubeFaceVisibility,
  cubeSnapshot,
  cubeLineVisibility,
  cubeCuttingData,
  cubeVisibilityData,
  cubeCurrentShadingData,
  cubeMeasurementsMarkup,
  cubeTransparencyData,
  getNodeIdsFromCubeUniqueId,
  getFileversionIdAndNodeOffsetIdMap,
  modelTransfroms,
  getFileVersionIdFromFileId,
} from "./cubeViewHelper";
import { CubeGlobal } from "@Features/viewer-core";

export const cubeView = {
  toJson: async (viewerImpl: any) => {
    const visibilityData = await cubeVisibilityData.toJson();

    const data: any = {
      camera: cubeCameraData.toJson(),
      sheetId: cubeSheetId.toJson(),
      explodeMagnitude: cubeMagnitudeData.toJson(),
      cuttingData: cubeCuttingData.toJson(),
      lineVisibility: cubeLineVisibility.toJson(),
      faceVisibility: cubeFaceVisibility.toJson(),
      defaultVisibility: visibilityData.defaultVisibility,
      visibilityExceptions: visibilityData.visibilityExceptions,
      colors: await cubeColorData.toJson(),
      markup: await cubeMarkup.toJson(),
      measurementsMarkup: await cubeMeasurementsMarkup.toJson(),
      selection: cubeSelectionData.toJson(),
      shading: cubeCurrentShadingData.toJson(),
      name: "asdf",
      uniqueId: createUuid(),
      transparencies: cubeTransparencyData.toJson(),
      modelTransfroms: modelTransfroms.toJson(),
    };

    if (viewerImpl._clippingBox.isActive()) {
      data.clippingBox = await viewerImpl._clippingBox.toJson();
    }

    return data;
  },
  fromJson: async (cubeViewJsonTemp: any, fileVersionId: any) => {
    // TODO: Discuss with purval and call getFileversionIdAndNodeOffsetIdMap globally as soon as all consitutent file loads

    const cubeViewJson = _.cloneDeep(cubeViewJsonTemp);
    const mapper = getFileversionIdAndNodeOffsetIdMap(fileVersionId);
    const colors: any[] = [];
    const visibilityExceptions: any[] = [];
    const selection: any[] = [];
    const transparencies: any[] = [];

    cubeViewJson.colors.forEach((color: any) => {
      const fileId = color[0].split("_")[0];
      const fileVersionId = getFileVersionIdFromFileId(fileId);
      const nodeIds = getNodeIdsFromCubeUniqueId(color[0], mapper, fileVersionId);
      nodeIds.forEach((node: any) => {
        colors.push([node, Color.fromJson(color[1])]);
      });
    });

    cubeViewJson.colors = colors;

    cubeViewJson.visibilityExceptions.forEach((exception: any) => {
      const fileId = exception.split("_")[0];
      const fileVersionId = getFileVersionIdFromFileId(fileId);
      const nodeIds = getNodeIdsFromCubeUniqueId(exception, mapper, fileVersionId);
      nodeIds.forEach((node: any) => {
        visibilityExceptions.push(node);
      });
    });

    cubeViewJson.visibilityExceptions = visibilityExceptions;

    cubeViewJson.selection.forEach((selectionData: any) => {
      const fileId = selectionData.nodeId.split("_")[0];
      const fileVersionId = getFileVersionIdFromFileId(fileId);
      const nodeIds = getNodeIdsFromCubeUniqueId(selectionData.nodeId, mapper, fileVersionId);
      nodeIds.forEach((node: any) => {
        selection.push({
          ...selectionData,
          nodeId: node,
        });
      });
    });

    cubeViewJson.selection = selection;

    cubeViewJson.transparencies.elements.forEach((transparentElements: any) => {
      const fileId = transparentElements.split("_")[0];
      const fileVersionId = getFileVersionIdFromFileId(fileId);
      const nodeIds = getNodeIdsFromCubeUniqueId(transparentElements, mapper, fileVersionId);
      nodeIds.forEach((node: any) => {
        transparencies.push(node);
      });
    });

    cubeViewJson.transparencies.elements = transparencies;

    await cubeMarkup.fromJson(cubeViewJson);
    if (Array.isArray(cubeViewJson.measurementsMarkup) && cubeViewJson.measurementsMarkup.length) {
      await cubeMeasurementsMarkup.fromJson(cubeViewJson.measurementsMarkup);
    }
    cubeViewJson.selection && cubeSelectionData.fromJson(cubeViewJson.selection);
    cubeViewJson.shading && cubeCurrentShadingData.fromJson(cubeViewJson.shading);
    if (Object.hasOwn(cubeViewJson, "transparencies")) {
      await cubeTransparencyData.fromJson(cubeViewJson.transparencies);
    }
    // if(Object.hasOwn(cubeViewJson, 'clippingBox')){
    //   await viewerImpl._clippingBox.fromJson(cubeViewJson.clippingBox)
    // }
    if (cubeViewJson.modelTransfroms) await modelTransfroms.fromJson(cubeViewJson.modelTransfroms);
  },
  flushView: async () => {
    await Promise.all([
      await CubeGlobal.hwv.model.resetNodesTransform(),
      CubeGlobal.hwv.measureManager.removeAllMeasurements(),
      CubeGlobal.hwv.selectionManager.clear(),
      CubeGlobal.hwv.model.resetNodesColor(),
      CubeGlobal.hwv.model.resetNodesVisibility(),
      CubeGlobal.hwv.model.resetModelOpacity(),
    ]);
  },
};

export const getCubeViewSnapshot = async () => await cubeSnapshot.toJson();
